// extracted by css-extract-rspack-plugin
export default {"item":"nwGEU"};